(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tb-ui/carousel/assets/javascripts/carousel-handler.js') >= 0) return;  svs.modules.push('/components/tb-ui/carousel/assets/javascripts/carousel-handler.js');

'use strict';

function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _classPrivateFieldSet(s, a, r) { return s.set(_assertClassBrand(s, a), r), r; }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
const createDragHandler = svs.components.tbUi.carousel.createDragHandler;
const DRAG_THRESHOLD = 50;
var _dragHandler = new WeakMap();
var _container = new WeakMap();
var _slides = new WeakMap();
var _previousButton = new WeakMap();
var _nextButton = new WeakMap();
var _scrollArea = new WeakMap();
var _live = new WeakMap();
var _intersector = new WeakMap();
var _navigation = new WeakMap();
var _navCurrentPage = new WeakMap();
var _navTotalPages = new WeakMap();
var _hasNavigation = new WeakMap();
class CarouselHandler {
  constructor(el) {
    _defineProperty(this, "el", void 0);
    _defineProperty(this, "currentIndex", 0);
    _classPrivateFieldInitSpec(this, _dragHandler, void 0);
    _classPrivateFieldInitSpec(this, _container, void 0);
    _classPrivateFieldInitSpec(this, _slides, []);
    _classPrivateFieldInitSpec(this, _previousButton, void 0);
    _classPrivateFieldInitSpec(this, _nextButton, void 0);
    _classPrivateFieldInitSpec(this, _scrollArea, void 0);
    _classPrivateFieldInitSpec(this, _live, void 0);
    _classPrivateFieldInitSpec(this, _intersector, void 0);
    _classPrivateFieldInitSpec(this, _navigation, void 0);
    _classPrivateFieldInitSpec(this, _navCurrentPage, void 0);
    _classPrivateFieldInitSpec(this, _navTotalPages, void 0);
    _classPrivateFieldInitSpec(this, _hasNavigation, false);
    this.el = el;

    this.setup = this.setup.bind(this);
    this.moveToPageIndex = this.moveToPageIndex.bind(this);
    this.updateNavigation = this.updateNavigation.bind(this);
    this.previous = this.previous.bind(this);
    this.next = this.next.bind(this);
    this.keyNavigtion = this.keyNavigtion.bind(this);
    this.onMove = this.onMove.bind(this);
    this.updateVisibility = this.updateVisibility.bind(this);
    this.setupListeners = this.setupListeners.bind(this);

    const observer = new MutationObserver(() => {
      if (document.contains(el)) {
        this.setup();
        observer.disconnect();
      }
    });
    observer.observe(document, {
      attributes: false,
      childList: true,
      characterData: false,
      subtree: true
    });
  }
  setup() {
    this.el.classList.remove('ui-carousel-loading');
    _classPrivateFieldSet(_container, this, this.el.querySelector('.js-carousel-container'));
    _classPrivateFieldSet(_intersector, this, this.el.querySelector('.js-carousel-container'));
    _classPrivateFieldSet(_scrollArea, this, this.el.querySelector('.js-carousel-items'));
    _classPrivateFieldSet(_slides, this, [..._classPrivateFieldGet(_scrollArea, this).children].map(slide => ({
      el: slide,
      actions: [...slide.querySelectorAll('.btn')]
    })));
    _classPrivateFieldSet(_previousButton, this, this.el.querySelector('.js-carousel-previous'));
    _classPrivateFieldSet(_nextButton, this, this.el.querySelector('.js-carousel-next'));
    _classPrivateFieldSet(_live, this, this.el.querySelector('.js-carousel-live'));
    _classPrivateFieldSet(_navCurrentPage, this, this.el.querySelector('.js-page-current'));
    _classPrivateFieldSet(_navTotalPages, this, this.el.querySelector('.js-page-total'));
    _classPrivateFieldSet(_hasNavigation, this, _classPrivateFieldGet(_slides, this).length > 1);
    if (_classPrivateFieldGet(_hasNavigation, this)) {
      var _classPrivateFieldGet2;
      _classPrivateFieldSet(_navigation, this, this.el.querySelector('.js-carousel-nav'));
      _classPrivateFieldGet(_navTotalPages, this).innerText = _classPrivateFieldGet(_slides, this).length;
      _classPrivateFieldGet(_navCurrentPage, this).innerText = this.currentIndex + 1;
      _classPrivateFieldGet(_live, this).innerText = "Sida ".concat(this.currentIndex + 1, " av ").concat(_classPrivateFieldGet(_slides, this).length);
      _classPrivateFieldGet(_previousButton, this).addEventListener('click', this.previous);
      _classPrivateFieldGet(_nextButton, this).addEventListener('click', this.next);
      if (this.currentIndex === 0) {
        this.disableButton(_classPrivateFieldGet(_previousButton, this));
      } else if (this.currentIndex > _classPrivateFieldGet(_slides, this).length - 1) {
        this.disableButton(_classPrivateFieldGet(_nextButton, this));
      }
      (_classPrivateFieldGet2 = _classPrivateFieldGet(_container, this)) === null || _classPrivateFieldGet2 === void 0 || _classPrivateFieldGet2.addEventListener('keyup', this.keyNavigtion);
      _classPrivateFieldSet(_dragHandler, this, createDragHandler(this.el));
      _classPrivateFieldGet(_dragHandler, this).registerCallbacks({
        onMove: this.onMove
      });
      _classPrivateFieldGet(_dragHandler, this).enable();
      this.setupListeners();
    }
  }
  setupListeners() {
    _classPrivateFieldGet(_container, this).style.setProperty('--scrollbar-width', '0px');
    const handleNavSticky = () => {
      const rect = _classPrivateFieldGet(_intersector, this).getBoundingClientRect();
      const isSticky = rect.top + 40 <= window.innerHeight && rect.bottom > window.innerHeight;
      if (isSticky) {
        _classPrivateFieldGet(_navigation, this).classList.add('ui-carousel-nav-sticky');
      } else {
        _classPrivateFieldGet(_navigation, this).classList.remove('ui-carousel-nav-sticky');
      }
    };
    const handleCarouselActive = () => {
      const rect = this.el.getBoundingClientRect();
      const isActive = rect.top <= window.innerHeight;
      if (isActive) {
        this.el.classList.remove('ui-carousel-inactive');
      } else {
        this.el.classList.add('ui-carousel-inactive');
      }
    };
    const debouncedHandleNavSticky = _.debounce(handleNavSticky, 100);
    const debouncedHandleCarouselActive = _.debounce(handleCarouselActive, 100);
    window.addEventListener('scroll', handleNavSticky);
    window.addEventListener('scroll', handleCarouselActive);
    window.addEventListener('resize', debouncedHandleNavSticky);
    window.addEventListener('resize', debouncedHandleCarouselActive);
    handleNavSticky();
    handleCarouselActive();
    window.addEventListener('beforeunload', () => {
      window.removeEventListener('scroll', handleNavSticky);
      window.removeEventListener('scroll', handleCarouselActive);
      window.removeEventListener('resize', debouncedHandleNavSticky);
      window.removeEventListener('resize', debouncedHandleCarouselActive);
    });
  }
  disableButton(btn) {
    btn.classList.add('disabled');
    btn.setAttribute('aria-disabled', 'true');
  }
  enableButton(btn) {
    btn.classList.remove('disabled');
    btn.removeAttribute('aria-disabled');
  }
  keyNavigtion(e) {
    switch (e.code) {
      case 'ArrowLeft':
        this.moveToPageIndex(Math.max(0, this.currentIndex - 1));
        break;
      case 'ArrowRight':
        this.moveToPageIndex(Math.min(_classPrivateFieldGet(_slides, this).length - 1, this.currentIndex + 1));
        break;
      default:
    }
  }
  previous() {
    if (this.currentIndex > 0) {
      this.moveToPageIndex(this.currentIndex - 1);
    }
  }
  next() {
    if (this.currentIndex + 1 < _classPrivateFieldGet(_slides, this).length) {
      this.moveToPageIndex(this.currentIndex + 1);
    }
  }
  updateNavigation(index) {
    _classPrivateFieldGet(_navCurrentPage, this).innerText = index + 1;
    _classPrivateFieldGet(_live, this).innerText = "Sida ".concat(index + 1, " av ").concat(_classPrivateFieldGet(_slides, this).length);

    if (index > this.currentIndex) {
      _classPrivateFieldGet(_nextButton, this).focus();
    } else if (index < this.currentIndex) {
      _classPrivateFieldGet(_previousButton, this).focus();
    }

    if (index === 0) {
      this.disableButton(_classPrivateFieldGet(_previousButton, this));
    } else {
      this.enableButton(_classPrivateFieldGet(_previousButton, this));
    }
    if (index === _classPrivateFieldGet(_slides, this).length - 1) {
      this.disableButton(_classPrivateFieldGet(_nextButton, this));
    } else {
      this.enableButton(_classPrivateFieldGet(_nextButton, this));
    }
  }
  updateVisibility(index) {
    _classPrivateFieldGet(_slides, this).forEach((_ref, i) => {
      let slide = _ref.el,
        actions = _ref.actions;
      if (i === index) {
        slide.removeAttribute('aria-hidden');
        actions.forEach(btn => btn.tabIndex = 0);
      } else {
        slide.setAttribute('aria-hidden', true);
        actions.forEach(btn => btn.tabIndex = -1);
      }
    });
  }
  onMove(_ref2) {
    let x = _ref2.x;
    if (Math.abs(x) > DRAG_THRESHOLD) {
      _classPrivateFieldGet(_dragHandler, this).release();
      const newIndex = x > 0 ? Math.max(0, this.currentIndex - 1) : Math.min(_classPrivateFieldGet(_slides, this).length - 1, this.currentIndex + 1);
      this.moveToPageIndex(newIndex);
    }
  }
  moveToPageIndex(index) {
    let instant = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    if (_classPrivateFieldGet(_hasNavigation, this)) {
      this.updateNavigation(index);
    }
    this.currentIndex = index;
    if (instant) {
      _classPrivateFieldGet(_scrollArea, this).classList.add('instant');
      requestAnimationFrame(() => {
        _classPrivateFieldGet(_scrollArea, this).style.transform = "translateX(".concat(index * 100 * -1, "%)");
        _classPrivateFieldGet(_scrollArea, this).classList.remove('instant');
      });
    } else {
      _classPrivateFieldGet(_scrollArea, this).style.transform = "translateX(".concat(index * 100 * -1, "%)");
    }
    this.updateVisibility(index);
  }
}
const createCarouselHandler = (el, shouldReduceMotion) => new CarouselHandler(el, shouldReduceMotion);
setGlobal('svs.components.tbUi.carousel', {
  createCarouselHandler,
  CarouselHandler
});

 })(window);